module.exports = __webpack_public_path__ + "img/434x0w.40897b51.webp";